import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  razorpayOrderApi,
  resetState,
} from "../../redux/features/razorpay/razorpayOrderSlice";
import { Backdrop, CircularProgress } from "@mui/material";
import { load } from "@cashfreepayments/cashfree-js";
import axiosInstance from "../../utils/axiosInstance";
import styles from "./Confirmation.module.scss";
import Loader from "../../components/Loader";
import CustomButton from "../../components/CustomButton";

const Confirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { sku } = location?.state?.coinDetail || {};
  const { _id } = location?.state?.address || {};

  const coinDetail = location?.state?.coinDetail || "";
  const address = location?.state?.address || "";

  const dispatch = useDispatch();

  const [orderTransactionId, setOrderTransactionId] = React.useState();

  const sliceResponse = useSelector(
    (state) => state.spotGoldProductDetailsSlice.spotGoldProductDetails.data
  );

  const { t } = useTranslation();
  const { checkout, purchaseDetails, deliveryAt } = t("confirmationPage");

  const [redeemLoading, setRedeemLoading] = useState(false);

  const getTransactionIdApi = async (TotalAmount) => {
    const payload = {
      productId: sku || "",
      addressId: _id || "",
    };

    try {
      setRedeemLoading(true);
      const response = await axiosInstance.post("/redeem/quote", payload);
      const transaction_Id = response?.data?.data?.merchantTransactionId || "";

      if (!transaction_Id) {
        return Swal.fire({
          title: "Unable to get transaction Id",
          icon: "error",
        });
      }

      setOrderTransactionId(transaction_Id);

      if (!response?.data?.error) {
        const payload = {
          TotalAmount,
          transaction_id: transaction_Id,
        };
        await dispatch(razorpayOrderApi(payload));
      } else {
        Swal.fire({
          title: response.data.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error fetching transaction ID:", error);
      Swal.fire({
        title: error?.response?.data?.message || "something went wrong!!!",
        icon: "error",
      });
    } finally {
      // setRedeemLoading(false);
    }
  };

  const razorpayOrderSliceResponse = useSelector(
    (state) => state.razorpayOrderSlice.data.data
  );

  // ==== CASH FREE======================

  const openCashfree = async () => {
    
    const cashfree = await load({
      mode: process.env.REACT_APP_CASHFREE,
    });
    
    let checkoutOptions = {
      paymentSessionId: razorpayOrderSliceResponse.payment_session_id,
      redirectTarget: "_modal",
    };
    
    cashfree.checkout(checkoutOptions).then((result) => {
      if (result.error) {
        setRedeemLoading(false);
        toast.error(result.error);
      }
      if (result.redirect) {
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {
        setRedeemLoading(false);
        // This will be called whenever the payment is completed irrespective of transaction status
        console.log("Payment has been completed, Check for Payment Status");

        // oderplaceApi();
        getRedeemData();
        dispatch(resetState());
      }
    });
  };

  const [loading, setLoading] = useState(false);

  const getRedeemData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/redeem/redeemInfo", {
        merchantTransactionId: orderTransactionId || "",
      });

      if (!response.data.error) {
        Swal.fire({
          title: response?.data?.message,
          icon: "success",
        });
        navigate("/dashboard/history");
      } else {
        Swal.fire({
          title: response?.data?.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error fetching transaction ID:", error);
      Swal.fire({
        title:
          error?.response?.data?.message ||
          error?.response?.message ||
          "something went wrong!",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // ====RAZORPAY CODE=============

  // const handleOpenRazorpay = async () => {
  //   const options = {
  //     key: `${process.env.REACT_APP_RAZORPAY_KEY}`,
  //     amount: razorpayOrderSliceResponse?.amount,
  //     currency: razorpayOrderSliceResponse?.currency,
  //     name: "Bharat Batuk Pvt.ltd.",
  //     description: "XYZ",
  //     order_id: razorpayOrderSliceResponse?.id,
  //     notes: {
  //       transactionId: orderTransactionId,
  //     },
  //     handler: function (response) {
  //       oderplaceApi();
  //       dispatch(resetState());
  //     },
  //   };

  //   const rzp = new window.Razorpay(options);

  //   // Handling payment failure
  //   rzp.on("payment.failed", function (response) {
  //     console.log("Payment failed:", response);
  //     Swal.fire({
  //       title: "Payment Failed",
  //       text: response.error.description,
  //       icon: "error",
  //     });
  //   });

  //   rzp.open();
  // };

  // const oderplaceApi = async () => {
  //   setLoading(true);

  //   const payload = {
  //     product1: coinDetail.sku,
  //     quantity1: "1",
  //     addressId: address._id,
  //     merchantTransactionId: orderTransactionId,
  //   };

  //   try {
  //     const res = await axiosInstance.post("/redeem/postOrder", payload);

  //     const responseData = res.data?.data?.[0];
  //     Swal.fire({
  //       title: "Payment Successful",
  //       text: `Transaction Number: ${responseData?.result?.data?.merchantTransactionId}`,
  //       icon: "success",
  //     });
  //     navigate("/dashboard/history");
  //   } catch (err) {
  //     console.error("Error occurred:", err);
  //     Swal.fire({
  //       title: "Payment Failed",
  //       text: "There was an issue with your transaction. Please try again.",
  //       icon: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (razorpayOrderSliceResponse?.id) {
  //     handleOpenRazorpay();
  //     // openCashfree();
  //   }

  //   return () => {
  //     dispatch(resetState());
  //   };
  // }, [razorpayOrderSliceResponse]);

  useEffect(() => {
    if (razorpayOrderSliceResponse?.payment_session_id) {
      // handleOpenRazorpay();
      openCashfree();
    }

    return () => {
      dispatch(resetState());
    };
  }, [razorpayOrderSliceResponse, dispatch]);

  return (
    <>
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", height: "80vh" }}
        >
          <Loader />
        </div>
      ) : (
        <>
          <h2 style={{ textAlign: "center" }}>{checkout}</h2>
          <div className={styles.main_container}>
            <div className={`universal_card ${styles.section1}`}>
              <div>
                <img
                  src={
                    location?.state?.coinDetail?.productImages[0]?.url ||
                    "/goldcoin.png"
                  }
                  alt="coin"
                  style={{ width: "140px" }}
                />
              </div>
              <div style={{ marginBottom: "1rem" }}>
                <h5>
                  {coinDetail?.metalType == "gold" ? "Gold" : "Silver"} Coin |{" "}
                  {coinDetail?.productWeight} Gms | {coinDetail?.purity} Purity
                </h5>
                {/* <h5>
                  {coinDetail.name ||
                    sliceResponse?.productName ||
                    "Default Name"}
                </h5> */}
                <p>
                  <span style={{ fontWeight: "600" }}>Weight :</span>{" "}
                  {coinDetail.productWeight ||
                    sliceResponse?.weight ||
                    "Default Weight"}{" "}
                  gm
                </p>
                <p>
                  <span style={{ fontWeight: "600" }}>
                    Delivery and Making Charges :
                  </span>{" "}
                  ₹
                  {coinDetail.basePrice ||
                    sliceResponse?.productPrice[0]?.finalProductPrice ||
                    "Default Price"}
                </p>
                <div style={{ marginTop: "0.5rem" }}>
                  <p>
                    {coinDetail.productWeight}gm {coinDetail.metalType} will be
                    deducted from your locker.
                  </p>
                </div>
              </div>
              <div className={styles.buy_btn_container}>
                <CustomButton
                  label="BUY NOW"
                  loading={redeemLoading}
                  disable={redeemLoading}
                  onClick={() => getTransactionIdApi(coinDetail.basePrice)}
                />
              </div>
            </div>
            <div className={`universal_card ${styles.section1}`}>
              <h5 className="colored">{purchaseDetails}</h5>
              <p>
                {coinDetail.description ||
                  sliceResponse?.metaDescription ||
                  "Default Description"}
              </p>
            </div>
            <div className={`universal_card ${styles.section1}`}>
              <h5 className="colored">{deliveryAt}</h5>
              <div>
                {address.line1} {address.line2}
              </div>
              <div>
                {address.city} {address.state}
              </div>
              <div>{address.mobileNumber}</div>
              <div>{address.zip}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Confirmation;
